import React, { useState, useContext } from 'react';
import { observer } from 'mobx-react';
import { useStore } from '../../sdo.js'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {withRouter} from "../../lib/react/withRouter";
import {useNavigate} from "react-router-dom";
import sso from "../../sso";

function Red_mnu(props) {
    var navigate = useNavigate();
    let [state, setState] = useState({mnu: "", rvn: 0, row: {}, htitle: "", ma: []});
    let ctx = useStore();

    var urlbas = "/pms/hotback";
    var lock = "lock";
    var moa = {};
    moa["f00"] = { fid: "f00", name: "Översikt", url: urlbas, icon: "home", fa: "fa fa-home flex", ma: [] };
    moa["f01"] = { fid: "f01", name: "Ekonomi", url: urlbas+"/eko", icon: "desktop", fa: "fa fa-desktop flex", ma: [] };
    moa["f02"] = { fid: "f02", name: "Statistik", url: urlbas+"/stat", icon: "bars", fa: "fa fa-bars flex", ma: [] };
    moa["f03"] = { fid: "f03", name: "Beläggning", url: urlbas+"/bel", icon: "users", fa: "fa fa-users flex", ma: [] };
    moa["f05"] = { fid: "f05", name: "Rapporter", url: urlbas+"/rps", icon: "utensils", fa: "fa fa-utensils flex", ma: [] };
    moa["f06"] = { fid: "f06", name: "Kontoplan", url: urlbas+"/kp", icon: "wrench", fa: "fa fa-wrench flex", ma: [] };
    moa["f07"] = { fid: "f07", name: "Dagsinfo", url: urlbas+"/di", icon: "cogs", fa: "fa fa-cogs flex", ma: [] };

    moa["f01"].ma.push( { fid: "m02", name: "Omsättning", url: urlbas+"/eko/oms", fa: "fa fa-bars" } );
    moa["f01"].ma.push( { fid: "m02", name: "Saldo", url: urlbas+"/eko/saldo", fa: "fa fa-bars" } );
    moa["f01"].ma.push( { fid: "m02", name: "Gäst Saldo", url: urlbas+"/eko/gstsaldo", fa: "fa fa-bars" } );
    moa["f01"].ma.push( { fid: "m02", name: "Bokningar", url: urlbas+"/eko/rvs", fa: "fa fa-bars" } );
    moa["f01"].ma.push( { fid: "m02", name: "Huvudbok", url: urlbas+"/eko/hbok", fa: "fa fa-bars" } );
    moa["f01"].ma.push( { fid: "m02", name: "Transaktioner", url: urlbas+"/eko/trs", fa: "fa fa-bars" } );
    moa["f01"].ma.push( { fid: "m02", name: "Notor", url: urlbas+"/eko/invs", fa: "fa fa-bars" } );

    //moa["f02"].ma.push( { fid: "m01", name: "Rumstyp", url: urlbas+"/bel/rt", fa: "fa fa-bars" } );

    var aa = [];
    var keys = Object.keys(moa);
    for(var key of keys) {
        var o = moa[key];
        aa.push( o );
    }

    //document.removeEventListener("mousedown", this.handleClick);
    document.addEventListener("mousedown", handleClick);

    var ma = [];
    var mnuHeight = window.innerHeight - 100;

   function handleClick(e) {
    if (e.pageX > 320) {
        if (state.ma.length) {
            setState({mnu : state.mnu, row : state.row, ma : [] });
            return;
        }
    }
  }
   function fknGo(row) {
    //var sdo = useContext(SDO);
    //alert(fkn);
    var fkn = row.fid;
    setState({ mnu : row.fid, row : row,  ma : [] });
    ctx.fid = fkn;

    //props.store.fkn = row;
    sso.seo.sfkn = row;
    navigate(row.url);
   };
   function fknFix(fkn) {
    //var sdo = useContext(SDO);
    //alert(fkn);
    ctx.fid = fkn;

    //if(fkn == "lock") history.push('/web');
    if(fkn == "logout") navigate('/pms');
   };
   function mnuGo(row) {
    //var sdo = useContext(SDO);
    //alert(fkn);
    //ctx.fid = fkn;
    setState({ mnu : state.hfid, row : state.row,  ma : [] });

        //props.store.fkn = row;
       sso.seo.sfkn = row;
       navigate(row.url);
   };
   function hideMnu() {
    setState({mnu : state.mnu, row : state.row, ma : [] });
   };
   function mouseEnter(it) {
    setState({mnu : state.mnu, row : state.row, hfid : it.fid, htitle : it.name, ma : it.ma });
   };
   function mouseLeave() {
    setState({mnu : state.mnu, row : state.row, ma : [] });
   };

   function row_css(row) {
  	    var css = {};
        css.margin = "0px";
        css.padding = "0px";
        css.height = "55px";
        css.borderBottom = "1px #ccc solid";

        if(sso.seo && (sso.seo.sfkn != undefined))
        {
            if (sso.seo.sfkn.fid == row.fid) {
               css.background = "#080";
               css.color = "#fff";
            }
        }
		return css;
    }
   function row_icon_css(row) {
  	    var css = {};
        css.paddingTop = "10px";
        css.fontSize = "20px";

        if(props.store.fkn && (props.store.fkn != undefined))
        {
            if (props.store.fkn.fid == row.fid) {
               //css.background = "#080";
               css.color = "#fff";
            }
        }
		return css;
    }

   //<Icon className={ it.fa } style={{ fontSize: 18 }} />
   var html =
        <div className="">
        <div className="cdi_xmnu flex-fullcol" style={{padding: "5px 0px"}}>
            { aa.map((it, key) =>
            <div key={ key } onClick={() => fknGo(it)} className="web-col flex-cc xmnu_tab" style={ row_css(it) } onMouseEnter={ () => mouseEnter(it) }>
                <FontAwesomeIcon icon={ it.icon } size="1x" className="" style={ row_icon_css(it) } />
                <div style={{fontSize: "10px"}}>{ it.name }</div>
            </div>
            )}
        </div>

        { state.ma.length ?
        <div className="mtrl_mnu_sub mtrl_mnu_bg" aria-label="Sub Menu" style={{height: mnuHeight}} onMouseLeave={mouseLeave}>
          <div className="mtrl_mnu_title" onClick={() => hideMnu()}>
            { state.htitle }
          </div>
            { state.ma.map((mi, key) =>
          <div key={key} className="mtrl_mnu_item flex-row" onClick={ () => mnuGo(mi) }>
            <div className="flex">{ mi.name }</div>
            <i className={ mi.fa } aria-hidden="true" style={ row_icon_css(mi) }></i>
          </div>
            )}
        </div>
        : null }
        </div>
    ;
    return html;
}

export default observer(Red_mnu);
